import { combineReducers } from 'redux';
import addMeasurementReducer from './AddMeasurement/AddMeasurement.slice';  

const measurementReducer = combineReducers({
    addMeasurement: addMeasurementReducer,
});

export default measurementReducer;